// extracted by mini-css-extract-plugin
export var menuIcon = "_qq-0";
export var menuIconInline = "_qq-1";